import { render, staticRenderFns } from "./get-an-assessment-a45.vue?vue&type=template&id=56ccd5c6&"
import script from "./get-an-assessment-a45.vue?vue&type=script&lang=js&"
export * from "./get-an-assessment-a45.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports